import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: .4rem .8rem .6rem 0rem;
  max-width: 100%;
  gap: 1.6rem;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const FormContainer = styled.form`
  display: flex;
  justify-content: space-between;
`

export const FiltersContainer = styled.div`
  display: flex;
  gap: 1.2rem;
`

export const GridPageInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  gap: 1.5rem;
  justify-content: space-between;
`

export const CustomTextField = styled(TextFieldMui)`
`

export const CustomSelectField = styled(SelectMui)`
`

export const CustomButton = styled(ButtonMui)`
  width: 15rem;    
  height: 2.4rem;
`

export const TableFooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: .4rem;
`

export const TableColumnActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
`
